<template>
  <router-view />
  <TechToast :toasts="toasts" />
  <AppLoadingOverlay />
</template>

<script setup lang="ts">
import { TechToast } from 'fire-iot-ui-template'
import { toast } from '@/utils/toast'
import AppLoadingOverlay from '@/components/AppLoadingOverlay.vue'

// 顶层 ref 在模板中会自动解包，避免把 ref 对象直接传给 TechToast 的 Array prop
const toasts = toast.toasts
</script>

<style scoped>
</style>
